import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './MandelicAcidPeel.css';

function MandelicAcidPeel() {
  const { t } = useTranslation();

  return (
    <div className="mandelic-acid-peel-page">
      {/* Hero Section */}
      <section className="mandelic-acid-peel-hero">
        <div className="container">
          <h1>Mandelic Acid Peel — Gentle Glow for All Skin Types</h1>
          <p className="hero-subtitle">
            Mandelic acid is a gentle AHA peel derived from bitter almonds, ideal for sensitive skin and darker skin tones. 
            It works on the surface to brighten, smooth, and restore clarity — with minimal downtime and visible radiance.
          </p>
          <p className="hero-note">
            Perfect for those who want a fresh, healthy glow without irritation.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="mandelic-acid-peel-content">
        <div className="container">
          <div className="content-wrapper">
            {/* What's Included */}
            <div className="content-section">
              <h2>What's Included</h2>
              <ul className="included-list">
                <li>Double cleanse</li>
                <li>Enzyme exfoliation (if required)</li>
                <li>Mandelic acid peel application</li>
                <li>Bespoke soothing mask</li>
                <li>Hydrating moisturiser and SPF</li>
              </ul>
            </div>

            {/* Benefits */}
            <div className="content-section">
              <h2>Benefits of Mandelic Acid</h2>
              <ul className="benefits-list">
                <li>Reduces pigmentation and dark spots</li>
                <li>Improves uneven skin tone</li>
                <li>Minimises blemishes and congestion</li>
                <li>Refines pores and skin texture</li>
                <li>Hydrates while exfoliating — gentle on dry/sensitive skin</li>
                <li>Brightens dull complexion</li>
                <li>Suitable for Fitzpatrick skin types I–VI</li>
              </ul>
              <div className="highlight-note">
                <p>
                  <strong>A brilliant option for first-time peel clients and those prone to irritation.</strong>
                </p>
              </div>
            </div>

            {/* Sessions Needed */}
            <div className="content-section">
              <h2>How Many Sessions Do I Need?</h2>
              <p>
                <strong>Course:</strong> 4–6 sessions every 1–2 weeks
              </p>
              <p>
                <strong>Maintenance:</strong> Monthly treatments for maintenance and long-term clarity
              </p>
            </div>

            {/* Not Suitable */}
            <div className="content-section">
              <h2>Not Suitable If You Are:</h2>
              <ul className="not-suitable-list">
                <li>Pregnant (check suitability first)</li>
                <li>Using strong active skincare such as retinol within the past 7 days</li>
                <li>Taking prescription acne medication</li>
                <li>Experiencing active infection, eczema, or psoriasis in the area</li>
                <li>Recently had Botox or fillers (less than 2 weeks)</li>
                <li>Sensitive or allergic to nuts (consultation required)</li>
              </ul>
            </div>

            {/* Managing Side Effects */}
            <div className="content-section">
              <h2>Managing Side Effects</h2>
              <p>
                Typical side effects are mild and short-lived:
              </p>
              <ul className="side-effects-list">
                <li>Light redness or sensitivity for a few hours</li>
                <li>Minor dryness or flaking</li>
                <li>Gentle warmth or tingling during application</li>
                <li>Slight tightness as skin renews</li>
              </ul>
              <div className="side-effects-note">
                <p>
                  <em>These are normal signs of exfoliation and skin refresh.</em>
                </p>
              </div>
            </div>

            {/* Post-Treatment Care */}
            <div className="content-section">
              <h2>Post-Treatment Care</h2>
              <h3>For the first 24–48 hours:</h3>
              <ul className="aftercare-list">
                <li>Avoid direct sunlight</li>
                <li>Apply SPF 30+ daily</li>
                <li>No makeup for 24 hours</li>
                <li>Gentle cleansing only</li>
                <li>Keep skin moisturised</li>
                <li>Avoid heavy exercise, steam rooms, and saunas</li>
                <li>Avoid swimming or chlorinated water</li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <h2>{t('services.cta.title')}</h2>
              <p>{t('services.cta.description')}</p>
              <div className="cta-buttons">
                <a href="https://www.fresha.com/book-now/sapium-beauty-hu8f8ild/all-offer?share=true&pId=2743251" target="_blank" rel="noopener noreferrer" className="cta-button primary">{t('services.cta.button')}</a>
                <Link to="/services" className="cta-button secondary">Back to Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MandelicAcidPeel;

